<template>
  <form id="sign-up-form" class="auth-form">
    <div class="auth-form-item">
      <label for="userEmail">
        {{ $t('AUTH.ENTRY_EMAIL') }}
      </label>
      <input id="userEmail" v-model="user.email"
             :class="{'error': msg.email}" type="text" placeholder="email-address@example.com"
      >
      <div v-show="msg.email" class="msg error" data-cy="errorMsgForEmail">
        {{ msg.email }}
      </div>
    </div>
    <div class="auth-form-item">
      <label for="userName">
        {{ $t('AUTH.ENTRY_USERNAME') }}
      </label>
      <input id="userName" v-model="user.name"
             :class="{'error': msg.name}" type="text"
      >
      <div v-show="msg.name" class="msg error" data-cy="errorMsgForName">
        {{ msg.name }}
      </div>
    </div>
    <div class="auth-form-item">
      <label for="userPass">
        {{ $t('AUTH.ENTRY_PASSWORD') }}
      </label>
      <input id="userPass" v-model="user.password"
             :class="{'error': msg.password}" type="password" @keyup.enter="signup"
      >
      <div v-show="msg.password" class="msg error" data-cy="errorMsgForPassword">
        {{ msg.password }}
      </div>
    </div>
    <div class="auth-form-item">
      <label for="userConfirm">
        {{ $t('AUTH.ENTRY_PASSWORD_CONFIRM') }}
      </label>
      <input id="userConfirm" v-model="user.password_confirmation"
             :class="{'error': msg.password_confirmation}" type="password" @keyup.enter="signup"
      >
      <div v-show="msg.password_confirmation" class="msg error" data-cy="errorMsgForPasswordConfirm">
        {{ msg.password_confirmation }}
      </div>
    </div>
    <div class="auth-form-item">
      <a :class="{'loading': loading}" :title="$t('AUTH.SIGN_UP')"
         class="mk-btn mk-btn--default auth-btn" @click="signup"
      >
        {{ $t('AUTH.SIGN_UP') }}
      </a>
    </div>
  </form>
</template>
<script>
export default {
  name: 'SignUpForm',
  components: {},
  directives: {},
  props: {},
  data() {
    return {
      loading: false,
      user: {
        'email': '',
        'name': '',
        'password': '',
        'password_confirmation': '' // backend api field name
      },
      msg: {
        'email': '',
        'name': '',
        'password': '',
        'password_confirmation': '' // backend api field name
      }
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // this.resetUser()
  },
  updated() {},
  methods: {
    resetMsg() {
      this.msg.email = ''
      this.msg.name = ''
      this.msg.password = ''
      this.msg.password_confirmation = ''
    },
    resetUser() {
      this.user = {
        'email': '',
        'name': '',
        'password': '',
        'password_confirmation': ''
      }
    },
    passSignUpValidation() {
      this.resetMsg()
      const emailRegExp = /\S+@\S+\.\S+/
      const invalidCharRegExp = /[!#$%^&*(),?'":{}|<>]+/g
      if (!this.user.email) {
        this.msg.email = this.$t('AUTH.REQUIRED')
      } else if (!emailRegExp.test(this.user.email)) {
        this.msg.email = this.$t('AUTH.INVALID_EMAIL_ERROR')
      } else if (invalidCharRegExp.test(this.user.email)) {
        this.msg.email = this.$t('AUTH.INVALID_CHAR_ERROR')
      }
      if (!this.user.name) {
        this.msg.name = this.$t('AUTH.REQUIRED')
      } else if (invalidCharRegExp.test(this.user.name)) {
        this.msg.name = this.$t('AUTH.INVALID_CHAR_ERROR')
      }

      if (!this.user.password) {
        this.msg.password = this.$t('AUTH.REQUIRED')
      } else if (this.user.password.length < 6) {
        this.msg.password = this.$t('AUTH.INVALID_PASS_LENGTH_ERROR')
      }
      if (!this.user.password_confirmation) {
        this.msg.password_confirmation = this.$t('AUTH.REQUIRED')
      } else if (this.user.password !== this.user.password_confirmation) {
        this.msg.password_confirmation = this.$t('AUTH.INVALID_PASS_AND_CONFIRN')
        if (!this.msg.password) this.msg.password = this.$t('AUTH.INVALID_PASS_AND_CONFIRN')
      }
      return !this.msg.email && !this.msg.name && !this.msg.password && !this.msg.password_confirmation
    },
    async signup() {
      if (this.passSignUpValidation() && !this.loading) {
        this.loading = true
        const data = await this.$store.dispatch('AUTH_REGISTER', this.user)
        if (data && data.id && data.email) {
          this.$store.dispatch('GTAG_EVENT', {
            action: 'sign_up',
            data: { 'method': 'Email' }
          })

          this.loading = false
          this.resetMsg()
          this.resetUser()
          this.$emit('reset', true)

          const redirectURL = this.$route.query.redirectURL || `/${this.$i81n.localePath()}`
          // this.$router.push({ name: 'signin', query: { type, redirectURL  } })
          if (redirectURL.match(/watch/g)) {
            window.location.href = redirectURL
          } else {
            this.$router.push(redirectURL)
            setTimeout(() => {
              this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_UP_SUCCESS', type: 'success', duration: 3500 })
            }, 500)
          }
        } else {
          this.loading = false
          if (data && data.errors) {
            if (data.errors.email && data.errors.email.indexOf('validation.unique') > -1) {
              this.msg.email = this.$t('AUTH.EMAIL_EXISTS')
            } else if (data.errors.email && data.errors.email.indexOf('Email 已被使用') > -1) {
              this.msg.email = this.$t('AUTH.EMAIL_EXISTS')
            }
          }
          this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_UP_ERROR', type: 'error' })
        }
      } else {
        this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.INVALID_INPUT_ERROR', type: 'error' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/auth/auth.scss';

</style>
